export default __webpack_public_path__ + "static/media/trash_ico.fe355102.svg";